const zipCodeRegExp = new RegExp(/^\d{5}$/);

export const validateZipCode = (value: string): string | null | undefined => {
  if (zipCodeRegExp.test(value)) {
    return undefined;
  }

  return 'Must be a valid 5 digit ZIP';
};
